import React, { useState } from 'react';

/**
 * Small (i) icon with CSS-only tooltip explaining how a metric is calculated.
 * No Bootstrap JS dependency — works purely with React state + CSS.
 */
const InfoTooltip = ({ text, placement = 'top' }) => {
  const [show, setShow] = useState(false);

  return (
    <span
      className="info-tooltip-wrapper"
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
      onFocus={() => setShow(true)}
      onBlur={() => setShow(false)}
      tabIndex={0}
      role="img"
      aria-label={text}
    >
      <i className="fas fa-info-circle info-tooltip-icon"></i>
      {show && (
        <span className={`info-tooltip-bubble placement-${placement}`}>
          {text}
        </span>
      )}
    </span>
  );
};

export default InfoTooltip;
